module.exports = __webpack_public_path__ + "static/coop-ad442e429c9de1b8853fab9ef295bf30.jpg";